import maEventBus from '@/components/eventbus/index.js'

/**
 * @module
 * @name Modal
 */
export default {
  name: 'ModalPhotoclaim',

  /**
   * @property {Boolean} showModal Used in pug v-if to handle and show component.
   */
  data: function () {
    return {
      showModal: false
    }
  },

  /**
   * @property {String} type Determines the type (usually size) of the modal.
   */
  props: {
    type: {
      type: String,
      required: true
    },

    closeIsHidden: {
      type: Boolean,
      default: false
    },

    allowFlash: {
      type: Boolean,
      default: false
    }
  },

  components: {
    maEventBus
  },

  /**
   * @property {String} modalClasses Returns concat of modal and type to use as
   *                                 CSS class.
   */
  computed: {
    modalClasses() {
      return `modalPhotoclaim--${this.type} `
    }
  },

  methods: {
    /**
     * @function
     * @name closeModal
     * @description Set show modal to false and emit an event.
     * @fires modal:close
     */
    closeModal: function () {
      this.showModal = false
      this.$emit('modal:close')
    },

    toggleFlash: function () {
      this.$emit('modal:flash')
    }
  },

  /**
   * @property {function} showModal Watcher, handle body scroll.
   */
  watch: {
    showModal: function () {
      if (this.showModal === true) {
        document.querySelector('body').style.overflow = 'hidden'
      } else {
        document.querySelector('body').style.overflow = 'visible'
      }
    }
  }
}
